/* eslint-disable */

export const
    SECONDS_YEAR = 3.154e7,
    MS_YEAR = SECONDS_YEAR * 1000,
    WORK_DAYS_MONTH = 21.74,
    WORK_DAYS_YEAR = 260,
    BASE_TRAVEL_MODE = 'driving',
    EXAMPLE_ROUTES = [
        'pw_Kzk6Ft', // Berlin -> Rome, Hybrid
        'dEvUUoOMz', // Sofia Airport -> Moscow
        'fkHhOs7A4', // Sofia -> London with airport
        'DrhU7VCJt', // Bucharest -> Munchen with plane and transit
        '7_iJ3Unm2', // New York -> San Francisco with electric fuel
        'mzsm6xQA3' // Sofia -> Copenhagen with many transit transports
    ],
    DAILY_ROUTE_DISTANCE = 50000,
    TREE_ABSORPTION_YEAR = 21772.4, // grams
    WALKING_EMISSIONS = 13,
    BICYCLING_EMISSIONS = 5.66,
    NOX_NO2 = 1.533,
    TRANSIT_DISTANCE_COACH = 50 * 1000, // km; transit is considered coach instead of bus if distance is above the value
    PLANE_EMISSIONS_BONUS = {
        base: 50000, // 50km more for takeoff and landing
        coef: 0.05 // 5% more because the plane doesn't fly in a straight line
    },
    TRANSIT_EMISSIONS = {
        PLANE:                  { passenger: 302, load: 0.71 }, // added from backend
        COACH:                  { passenger: 32, load: 0.60 }, // locally added
        BUS:                    { passenger: 76, load: 0.21 },
        INTERCITY_BUS:          { passenger: 32, load: 0.60 },
        TROLLEYBUS:             { passenger: 55, load: 0.55 },
        TRAM:                   { passenger: 65, load: 0.55 },
        TRAIN:                  { passenger: 67, load: 0.28 },
        COMMUTER_TRAIN:         { passenger: 67, load: 0.28 },
        LONG_DISTANCE_TRAIN:    { passenger: 47, load: 0.50 },
        HIGH_SPEED_TRAIN:       { passenger: 47, load: 0.50 },
        RAIL:                   { passenger: 41, load: 0.50 },
        HEAVY_RAIL:             { passenger: 47, load: 0.50 },
        METRO_RAIL:             { passenger: 67, load: 0.28 },
        SUBWAY:                 { passenger: 67, load: 0.28 },
        MONORAIL:               { passenger: 41, load: 0.50 }
    },
    FUELS = {
        petrol: {
            consumptionCoef: 1,
            emissionsLitre: 2392,
            noxLitre: 0.6
        },
        diesel: {
            consumptionCoef: 0.8,
            emissionsLitre: 2640,
            noxLitre: 8
        },
        lpg: {
            consumptionCoef: 1.3,
            emissionsLitre: 1665,
            noxLitre: 3
        },
        hybrid: {
            consumptionCoef: 0.4,
            emissionsLitre: 2392,
            emissionsKwh: 413,
            noxLitre: 8
        },
        electric: {
            consumptionCoef: 1,
            emissionsKwh: 413
        }
    },
    CONSUMPTION_AMOUNT = {
        default: {
            mini: 7.84,
            small: 10.2,
            medium: 12.9,
            luxury: 14.07,
            sport: 13.4,
            van: 13.74,
            suv: 17.25,
            other: 17.67
        },
        electric: {
            mini: 14.05,
            small: 17.75,
            medium: 18.64,
            luxury: 18.33,
            sport: 18.94,
            van: 22.70,
            suv: 20.93,
            other: 24.92
        } 
    };

export const LOADING_TEXTS = [
    'Counting CO<sub>2</sub> molecules…',
    'Crunching the numbers…',
    'Measuring distance…',
    'Sampling fuel…',
    'Doing math…',
    'Predicting traffic…',
    'Running tests…'
];